import { createSelector } from 'reselect'

export const isInitiating = state => state.eulaReducer.status.initiating
export const isShowing = state => state.eulaReducer.status.showing
export const isInValid = state => state.eulaReducer.status.inValid
export const isAccepted = state => state.eulaReducer.status.accepted
export const isDeclined = state => !state.eulaReducer.status.accepted
export const isFinished = state => state.eulaReducer.status.finished
export const getEulaUserId = state => state.eulaReducer.status.userId

export const getStatus = createSelector(
    [isInitiating, isShowing, isInValid, isAccepted, isFinished],
    (initiating, showing, inValid, accepted, finished) => {
        if (initiating) return 0
        if (showing) return 1
        if (inValid) return 2
        if (!finished) return -1
        return accepted ? 3 : 4
    },
)



// WEBPACK FOOTER //
// ./src/features/Eula/data/status/selectors.js